import axios from "axios";

export const getTrucks = async () => {
  try {
    const res = await axios.get(
      "https://caldenflow.cn-grupo.net:15443/api/getCamiones"
    );
    return res.data;
  } catch (error) {
    console.error("Error al obtener los camiones:", error);
    return null;
  }
};
